export const PASSWORD_STRENGTH = {
  WEAK: 'weak',
  STRONG: 'strong',
} as const;

const has8length = /(?=.{8,})/;
const hasLowercase = /(?=.*[a-z])/;
const hasUppercase = /(?=.*[A-Z])/;
const hasSpecialCharacter = /(?=.*[^A-Za-z0-9])/;

const strongRegexArray = [
  has8length,
  hasLowercase,
  hasUppercase,
  hasSpecialCharacter,
];

export type PasswordStrength = keyof typeof PASSWORD_STRENGTH;

export const checkPasswordStrength = (value: string) => {
  if (strongRegex(value)) return PASSWORD_STRENGTH.STRONG;

  return PASSWORD_STRENGTH.WEAK;
};

export const isPasswordValid = (value: string) => {
  const passwordStrength = checkPasswordStrength(value);

  return passwordStrength === PASSWORD_STRENGTH.STRONG;
};

const strongRegex = (value: string) => testRegexes(strongRegexArray, value);

const testRegexes = (regexArray: RegExp[], value: string) =>
  regexArray.every((regex) => regex.test(value));
